module.exports = __webpack_public_path__ + "static/img/65-2.0ac1599.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/65-2.jpg
// module id = osWY
// module chunks = 0